module.exports = __webpack_public_path__ + "static/media/club_full2.91176281.jpg";